import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@feathr/components';
import ErrorPage from '@feathr/extender/App/ErrorPage';
import { useLocalUrl } from '@feathr/extender/state';

function PermissionRequired(): JSX.Element {
  const localUrl = useLocalUrl();
  const { t } = useTranslation();

  return (
    <ErrorPage
      description={t('Contact an administrator or try logging in with a different account.')}
      title={t('Permission required')}
    >
      <Button href={localUrl('/')} type={'primary'}>
        {t('Take me home')}
      </Button>
    </ErrorPage>
  );
}

export default PermissionRequired;
